import type { Permission } from '@traton/devportal-rbac-common-lib';

export const techdocsFeedbackReadPermission: Permission = {
  name: 'techdocs.feedback.read',
  type: 'basic',
  attributes: { action: 'read' },
};

export const techdocsFeedbackUpdatePermission: Permission = {
  name: 'techdocs.feedback.update',
  type: 'basic',
  attributes: { action: 'update' },
};

export const techdocsFeedbackPermissions = [
  techdocsFeedbackReadPermission,
  techdocsFeedbackUpdatePermission,
];
